import React from 'react';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

export const StoreItemCard = ({ item, onBuy }) => {
  const handleBuy = () => {
    if (onBuy) {
      onBuy(item);
    }
  };

  return (
    <Card className="w-full hover:translate-x-boxShadowX hover:translate-y-boxShadowY transition-all">
      <CardHeader className="p-4 pb-2">
        <div className="aspect-square bg-pinkAccent rounded-base border-2 border-border flex items-center justify-center overflow-hidden">
          <img
            src={item.image}
            alt={item.name}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = '/placeholder-item.png';
            }}
          />
        </div>
      </CardHeader>
      <CardContent className="p-4 pt-2">
        <CardTitle className="text-lg mb-2 text-white">{item.name}</CardTitle>
        <p className="text-sm text-text/70 min-h-[3rem] text-white">{item.description}</p>
      </CardContent>
      <CardFooter className="p-4 pt-0 flex flex-col gap-2">
        <div className="w-full bg-main rounded-base border-2 border-border p-2 text-center">
          <span className="font-heading text-lg">{item.price} $CHI</span>
        </div>
        <Button
          onClick={handleBuy}
          className="w-full bg-pink hover:bg-pinkAccent text-white font-base"
        >
          立即购买 Buy Now
        </Button>
      </CardFooter>
    </Card>
  );
};
